var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundEgg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 563,
    height: 596,
    viewBox: "0 0 563 596",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M504.035 197.061C591.088 298.977 579.543 451.735 478.25 538.257C376.956 624.779 224.271 612.299 137.218 510.384C50.1657 408.468 -60.8852 112.183 40.4085 25.6612C141.702 -60.8603 416.983 95.1459 504.035 197.061Z",
    fill: "#F8F8FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundEgg4);
export default __webpack_public_path__ + "static/media/background-egg-4.a7ad25760aef2db9774c246cbd5e2c61.svg";
export { ForwardRef as ReactComponent };